import { Component, OnInit, Input, EventEmitter, Output, OnChanges, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Title } from './title.interface';
import { CommonService } from '../services/common.service';
import * as appApiResources from '../../shared/globalcontants';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    imports: [NgClass, NgbTooltip, MatMenuTrigger, MatMenu, MatMenuItem, MatButton]
})
export class TitleComponent implements OnInit, AfterViewInit, OnChanges {

  showTitle: any = true;
  back: any = false;
  action: any = false;
  voiceAssistantActionShow: any = false;
  voiceAssistantActionDisabled: any = false;
  edit: any = false;
  more: any = false;
  innerHeader: any = false;
  buttonText: any = '';
  pageTitle: any;
  requisition: any = false;
  poRequisition: any = false;
  isReconcile: boolean;
  poReqTooltipText: any;
  moreOptions: any;
  disableEdit: any;
  iconName = 'icon-down';
  delete: boolean;
  enableBackAction = true;
  @ViewChild('appTittle') appTittle: ElementRef;
  @Input() options: Title;
  @Output() backEvent: EventEmitter<any> = new EventEmitter();
  @Output() actionEvent: EventEmitter<any> = new EventEmitter();
  @Output() voiceAssistantActionEvent: EventEmitter<any> = new EventEmitter();
  @Output() editEvent: EventEmitter<any> = new EventEmitter();
  @Output() moreEvent: EventEmitter<any> = new EventEmitter();
  @Output() loadRequisitionEvent: EventEmitter<any> = new EventEmitter();
  @Output() reconcile: EventEmitter<any> = new EventEmitter();
  @Output() loadReq: EventEmitter<any> = new EventEmitter();
  @Output() loadReqApproved: EventEmitter<any> = new EventEmitter();
  @Output() titleClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() MoreOptionsClicked: EventEmitter<any> = new EventEmitter();
  @Output() syncClicked: EventEmitter<any> = new EventEmitter();
  @Output() mailEvent: EventEmitter<any> = new EventEmitter();
  @Output() deleteEvent: EventEmitter<any> = new EventEmitter();
  sync = false;
  disableSync = false;
  disableAction = false;
  disablerequisition = false;
  previlege: any;
  mail: any;
  messageCount: number = 0;
  constructor(private _cs: CommonService) {
    this.previlege = appApiResources.PREVILEGEKEY;
  }
  deleteClick(e) {
    this.deleteEvent.emit([e]);
  }

  backClick(e) {
    this.backEvent.emit([e]);
    this._cs.disableEdit.next(true);
  }

  actionClick(e) {
    this.actionEvent.emit([e]);
  }

  voiceAssistantActionClick(e) {
    this.voiceAssistantActionEvent.emit([e]);
  }

  sendMailClick(e) {
    this.mailEvent.emit([e]);
  }

  editClick(e) {
    if (!this.disableEdit) {
      this.editEvent.emit([e]);
    }
  }

  moreClick(e) {
    this.moreEvent.emit([e]);
  }

  loadRequisitionClick(e) {
    this.loadRequisitionEvent.emit([e]);
  }

  Reconcile(event){
    this.reconcile.emit([event]);
  }

  loadReqClick(e, id) {
    this.loadReq.emit([e, id]);
  }
  loadReqApprovedClick(e) {
    this.loadReqApproved.emit([e]);
  }

  titleClick(e) {
    if (this.back) {
      this.backEvent.emit(e);
    }

  }

  ngAfterViewInit() {
  this._cs.appTittleElementRef = this.appTittle;
  }
  ngOnChanges() {
    if (typeof this.options !== 'undefined') {
      this._cs.messageCount.subscribe((value: number) => this.messageCount = value);
      this._cs.disableEdit.subscribe((value: boolean) => {
        this.disableEdit = value === false ? !value : this.options.disableEdit !== undefined ? this.options.disableEdit : false;
      });
      this.pageTitle = this.options.pageTitle;
      this.back = this.options.back  !== undefined ? this.options.back : false;
      this.action = this.options.action !== undefined ? this.options.action : false;
      this.voiceAssistantActionShow = this.options.voiceAssistantActionShow !== undefined ? this.options.voiceAssistantActionShow : false;
      this.voiceAssistantActionDisabled = this.options.voiceAssistantActionDisabled !== undefined ? this.options.voiceAssistantActionDisabled : false;
      this.edit = this.options.edit !== undefined ? this.options.edit : false;
      this.more = this.options.more !== undefined ? this.options.more : false;
      this.requisition = this.options.requisition ? this.options.requisition : false;
      this.isReconcile = this.options.isReconcile ? this.options.isReconcile : false;
      this.buttonText = this.options.buttonText !== undefined ? this.options.buttonText : '';
      this.innerHeader = this.options.innerHeader !== undefined ? this.options.innerHeader : false;
      this.poRequisition = this.options.poRequisition !== undefined ? this.options.poRequisition : false;
      this.poReqTooltipText = this.options.poReqTooltipText !== undefined ? this.options.poReqTooltipText : false;
      this.showTitle = this.options.showTitle !== undefined ? this.options.showTitle : true;
      this.moreOptions = this.options.moreOptions;
      this.sync = this.options.sync !== undefined ? this.options.sync : false;
      this.mail = this.options.mail !== undefined ? this.options.mail : false;
      this.delete = this.options.delete !== undefined ? this.options.delete : false;
      // this.sync = this.options.sync != undefined ? this.options.sync :false;
      // this.disableEdit = true;
     }

  }
  ngOnInit() {
   console.log('test');
  }

  moreOptionsClicked(event, name) {
    this.MoreOptionsClicked.emit([event, name]);
  }

  syncClick(event) {
    this.syncClicked.emit([event]);
  }

}
